import i18n, { initI18n, setLocale } from '@link/share/i18n';
import shareLangEn from '@link/share/i18n/lang/en';
import shareLangJa from '@link/share/i18n/lang/ja';
import shareLangKo from '@link/share/i18n/lang/ko';
import shareLangZh from '@link/share/i18n/lang/zh';
import shareLangZt from '@link/share/i18n/lang/zt';
import { LocaleOption } from '@link/skytree/services/types';
import en from './lang/en';
import ja from './lang/ja';
import ko from './lang/ko';
import zh from './lang/zh';
import zt from './lang/zt';

/**
 * LINK-5548: the nationality label reads "country or region of residence" on
 * this site only. The key lives in @link/share, which every other app reads
 * unchanged, so the override is applied here — spreading the shared block back
 * in, because `resources()` merges the top level shallowly.
 */
const withResidenceCountry = <T extends { profile: { country: string } }>(
  share: T,
  country: string
) => ({
  ...share,
  profile: {
    ...share.profile,
    country
  }
});

initI18n({
  enText: {
    share: withResidenceCountry(
      shareLangEn.share,
      'Country or region of residence'
    ),
    views: {
      privacy: shareLangEn.privacy,
      terms: shareLangEn.terms,
      booking: shareLangEn.booking,
      ...en.views,
      bookResult: shareLangEn.bookResult
    }
  },
  jaText: {
    share: withResidenceCountry(shareLangJa.share, 'お住まいの国または地域'),
    views: {
      privacy: shareLangJa.privacy,
      terms: shareLangJa.terms,
      booking: shareLangJa.booking,
      ...ja.views,
      bookResult: shareLangJa.bookResult
    }
  },
  koText: {
    share: withResidenceCountry(shareLangKo.share, '거주 국가 또는 지역'),
    views: {
      privacy: shareLangKo.privacy,
      terms: shareLangKo.terms,
      booking: shareLangKo.booking,
      ...ko.views,
      bookResult: shareLangKo.bookResult
    }
  },
  zhText: {
    share: withResidenceCountry(shareLangZh.share, '居住国家或地区'),
    views: {
      privacy: shareLangZh.privacy,
      terms: shareLangZh.terms,
      booking: shareLangZh.booking,
      ...zh.views,
      bookResult: shareLangZh.bookResult
    }
  },
  ztText: {
    share: withResidenceCountry(shareLangZt.share, '居住國家或地區'),
    views: {
      privacy: shareLangZt.privacy,
      terms: shareLangZt.terms,
      booking: shareLangZt.booking,
      ...zt.views,
      bookResult: shareLangZt.bookResult
    }
  }
});

export { setLocale };

export const SHUTTO_LOCALE_OPTIONS = [
  { label: 'Deutsch', value: 'de' },
  { label: 'Français', value: 'fr' },
  { label: 'Español', value: 'es' }
] as const;

export const SHUTTO_LOCALE_VALUES = SHUTTO_LOCALE_OPTIONS.map(
  locale => locale.value
);

export const getLocaleValues = (options: readonly LocaleOption[]): string[] =>
  options.map(locale => locale.value);

export default i18n;
